import { useRecoilValue } from 'recoil'
import { building, timeframe } from '../../store'
import { getTimeframe, TimeframeVariant } from '../../utils/getTimeframe'
import { useQuery, useSuspenseQuery } from '@apollo/client'
import { GET_WINDOWED_MEASUREMENTS_QUERY } from '../queries/metrics'
import { useMemo } from 'react'
import { GetGridForPowerOverviewQuery } from '../../dashboard/queries/gridForPowerOverview'
import { energyTableGetTotal, energyTableGetValues } from '../../dashboard/dashboards/PowerOverviewComponents/PowerOverviewEnergyTable'
import Big from 'big.js'
import { EnergyTableSingleCategoryColumn } from '../../components/Energy/EnergyTable/EnergyTableSingleCategoryColumn'
import { EnergyTypes } from '../../components/Energy/EnergyTable/EnergyTableResult'

export const EnergyCategorySolarColumn = () => {
  const { activeBuildingId } = useRecoilValue(building)
  const selectedTimeframe = useRecoilValue(timeframe)
  const { start, end, window } = getTimeframe({ ...selectedTimeframe, variant: TimeframeVariant.CONDENSED })

  const { data: gridLayoutData } = useSuspenseQuery(GetGridForPowerOverviewQuery, {
    variables: {
      buildingId: activeBuildingId
    },
    skip: !Boolean(activeBuildingId)
  })

  const solarDevices = useMemo(() => {
    if (gridLayoutData?.getBuilding?.grid?.solar && gridLayoutData?.getBuilding?.grid?.solar.length > 0) {
      //@ts-ignore
      return gridLayoutData.getBuilding.grid.solar.map(entry => entry.deviceId)
    }
    return []
  }, [gridLayoutData])

  const { data: solarExport } = useSuspenseQuery(GET_WINDOWED_MEASUREMENTS_QUERY, {
    variables: {
      input: {
        deviceId: solarDevices,
        start,
        end,
        measurement: 'energyExported',
        window
      }
    },
    fetchPolicy: 'no-cache',
    pollInterval: window === '24h' ? 5000 : 0,
    skip: !Boolean(solarDevices && solarDevices.length > 0)
  })

  const solar = useMemo(() => {
    if (!solarExport?.getWindowedMeasurements || solarExport.getWindowedMeasurements.length < 1)
      return {
        total: 0,
        values: []
      }

    const total = energyTableGetTotal(solarExport.getWindowedMeasurements)
    const values = energyTableGetValues(solarExport.getWindowedMeasurements, selectedTimeframe)

    return {
      total: total.round(0, Big.roundHalfUp).toNumber(),
      values
    }
  }, [solarExport?.getWindowedMeasurements, selectedTimeframe])

  return <EnergyTableSingleCategoryColumn title={'Opwek'} type={EnergyTypes.Solar} total={solar.total} resultMax={solar.total} values={solar.values} />
}
